<!-- prettier-ignore -->

<ion-header class="register-header">
    <ion-toolbar>
        <span>{{'Regístrate' | translate}}</span>
        <ion-icon (click)="dismissModal()" name="close"></ion-icon>
    </ion-toolbar>
</ion-header>

<div class="register-modal">

    <form class="register-form" [formGroup]="registerForm" (ngSubmit)="register()" #registerFormRef="ngForm">
        <p>¡{{'Te damos la bienvenida a' | translate}} EMT Smart Tourism!</p>

        <div class="form-group-register" >
            <label class="labels">
                <span [ngClass]="{'error-color': registerFormRef.submitted && f.email.invalid}">{{'Correo electrónico' | translate}}</span> *
            </label>
            <div class="divInputStyle">
                <input autocomplete="off" [type]="'text'" (focusin)="focusin($event)" id="email" formControlName="email" class="inputs-pdf" />
            </div>

            @if(registerFormRef.submitted && f.email.invalid && (f.email.dirty || f.email.touched)){
                <div class="error-wrapper">
                    @if(f.email.errors.required){
                        <div>{{'Email es requerido' | translate}}</div>
                    }
                    @if(f.email.errors.email){
                        <div>{{'Email no válido' | translate}}</div>
                    }
                </div>
            }


        </div>

        <div class="form-group-register" >
            <label class="labels">
                <span>{{'Contraseña' | translate}}</span> *
            </label>
            <div class="divInputStyle">
                <input autocomplete="off" [type]="passwordType" (focusin)="focusin($event)" id="password" formControlName="password" class="inputs-pdf" />
                <ion-icon (click)="showPassword()" class="show-button" name="eye-off"></ion-icon>
            </div>

            @if(registerFormRef.submitted && f.password.invalid && (f.password.dirty || f.password.touched)){
                <div class="error-wrapper" >
                    @if(f.password.errors.required){
                        <div>{{'Contraseña es requerida' | translate}}</div>
                    }
                    @if(f.password.errors.minlength){
                        <div>{{'Contraseña debe tener al menos 6 caracteres' | translate}}</div>
                    }
                </div>
            }

        </div>

        <div class="form-group-register" >
            <label class="labels">
                <span>{{'Confirma Contraseña' | translate}}</span> *
            </label>
            <div class="divInputStyle">
                <input autocomplete="off" [type]="passwordType" (focusin)="focusin($event)" id="confirmPassword" formControlName="confirmPassword" class="inputs-pdf" />
                <ion-icon (click)="showPassword()" class="show-button" name="eye-off"></ion-icon>
            </div>

            @if(registerFormRef.submitted && registerForm.hasError('notSame') && (registerForm.get('confirmPassword').dirty || registerForm.get('confirmPassword').touched)){
                <div class="error-wrapper">
                    {{'Las contraseñas no coinciden' | translate}}
                </div>
            }

        </div>

        <div class="accept-terms">
            <input formControlName="checkBox" type="checkbox" name="check">
            <span [ngStyle]="{color: registerFormRef.submitted && !checkConditions ? 'red' : '#000'}">
                {{'He leído y acepto los términos y condiciones de uso' | translate}}
            </span>
        </div>
            <div class="policy-text">
                <strong class="blue">{{'Responsable del tratamiento' | translate}}:</strong> {{'Empresa Municipal de Transportes de Madrid, S.A' | translate }}. (“<strong>EMT”</strong>).<br>
                <strong class="blue">{{'Finalidades' | translate}}:</strong> F{{'acilitar a los usuarios rutas y lugares de interés a visitar en la ciudad de Madrid según las preferencias indicadas' | translate}}. {{'En caso de registrarse como usuario en la aplicación, poner a su disposición las rutas planificadas y los históricos de actividad' | translate}}. {{'Si lo desea, ofrecerle la posibilidad de contratar servicios de movilidad a través de la aplicación mPass/ MM360 de EMT' | translate}}.<br>
                <strong class="blue">{{'Derechos' | translate}}:</strong> {{'Puede consultar la información ampliada y cómo ejercitar sus derechos en este' | translate}} <a href="https://www.emtmadrid.es/privacidad/turismoInteligente.aspx" target="_blank">{{'link' | translate}}</a><br>
            </div>
        <button type="submit" [disabled]="registerFormRef.submitted && registerForm.invalid" class="submit-button">{{'Registrar' | translate}}</button>
    </form>

</div>